import React, { useCallback, useEffect, useState } from 'react';
import ImageGallery from 'react-image-gallery';
import 'react-image-gallery/styles/css/image-gallery.css';
import { ImageNav } from '@components/atoms';
import { PDFViewer } from '@components/molecules';
import { makeStyles } from '@material-ui/core/styles';
import { faChevronLeft, faChevronRight } from '@fortawesome/free-solid-svg-icons';

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    justifyContent: 'space-between',
  },
}));

const ImgGallery = ({ showNav, images, fullscreen, pdfTitle }) => {
  const [isPDF, setIsPDF] = useState(false);
  const [showFullScreenButtonOption, setShowFullScreenButtonOption] = useState(false);
  const [firstImageIsPDF, setFirstImageIsPDF] = useState(false);
  const [secondImageIsPDF, setSecondImageIsPDF] = useState(false);

  const classes = useStyles();

  const renderLeftNav = (onClick, disabled) => (
    <ImageNav onClick={onClick} disabled={disabled} iconName={faChevronLeft} direction="left" />
  )
  const renderRightNav = (onClick, disabled) => (
    <ImageNav onClick={onClick} disabled={disabled} iconName={faChevronRight} direction="right" />
  )

  const checkImage = useCallback(() => {
    for (let i = 0; i < images.length; i++) {
      if (images[i].original.slice(0, 28).includes('pdf')) {
        setIsPDF(true);
        if (i === 0) {
          setFirstImageIsPDF(true);
        } else if (i === 1) {
          setSecondImageIsPDF(true);
        }
      } else {
        setIsPDF(false);
      }
      if (!images[i].original.includes('null') && fullscreen) {
        setShowFullScreenButtonOption(true);
      } else {
        setShowFullScreenButtonOption(false);
      }
    }
  }, [images]);

  useEffect(() => {
    checkImage();
  }, [checkImage, images]);

    return ( 
      <> 
        {
          !isPDF ?
            <ImageGallery
                items={images}
                showThumbnails={false}
                lazyLoad={true}
                showPlayButton={false}
                useBrowserFullscreen={false}
                showNav={showNav}
                showFullscreenButton={showFullScreenButtonOption}
                renderLeftNav={renderLeftNav}
                renderRightNav={renderRightNav}
                className={classes.root}
            />
          :
          <>
            {firstImageIsPDF && (<PDFViewer title={pdfTitle} fileUrl={images[0].original} />)}

            {secondImageIsPDF && images[1].original && (<PDFViewer title={pdfTitle} fileUrl={images[0].original} />)}
          </>
      }
    </>
  )
};

export default ImgGallery;